import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import get from 'lodash.get';
import isEqual from 'lodash.isequal';

// Types
// TODO
// import { AppState } from 'services/types';

// Selectors
import {
    selectSelectedTableCellsColumnName,
    selectSelectedTableCellRows
    // @ts-ignore
} from 'services/selectedTableCells/selectors';

interface FormState {
    initialValues: {
        [key: string]: any;
    };
    values: {
        [key: string]: any;
    };
    valid: boolean;
}

export interface OwnProps {
    batch: Function;
    change: Function;
    format: Function;
    formProps: FormState;
}

interface ConnectedProps {
    columnName?: string;
    rows: string[];
}

type Props = OwnProps & ConnectedProps;

export class FormBulkChange extends React.Component<Props> {
    componentDidUpdate(prevProps: Props): void {
        const { formProps } = this.props;

        if (!isEqual(prevProps.formProps.values, formProps.values)) {
            this.handleBulkChange();
        }
    }

    handleBulkChange = (): void => {
        const {
            columnName,
            rows,
            batch,
            change,
            format,
            formProps: { values }
        } = this.props;

        if (rows.length > 1 && columnName) {
            const active = rows[rows.length - 1];
            const fieldValue = get(values, `${active}.${columnName}`);

            batch((): void => {
                rows.forEach((row: string): void => {
                    if (row !== active) {
                        const previousValue = get(values, row);

                        if (previousValue) {
                            let nextValue = {
                                ...previousValue,
                                [columnName]: fieldValue,
                                // HACK component no longer genereic
                                // We need to know if a break is edited so that we can prevent them from being auto calculated
                                hasEditedPaidBreak:
                                    previousValue.hasEditedPaidBreak ||
                                    columnName === 'paidBreakMinutes',
                                hasEditedUnpaidBreak:
                                    previousValue.hasEditedUnpaidBreak ||
                                    columnName === 'unpaidBreakMinutes'
                            };

                            if (format) {
                                nextValue = format(nextValue);
                            }

                            change(row, nextValue);
                        }
                    }
                });
            });
        }
    };

    render(): null {
        return null;
    }
}

const mapStateToProps = createStructuredSelector<
    any, // AppState,
    OwnProps,
    ConnectedProps
>({
    columnName: selectSelectedTableCellsColumnName,
    rows: selectSelectedTableCellRows
});

export default connect(mapStateToProps)(FormBulkChange);
